<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-04 16:12:36
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:26:13
-->
<template>
  <div
    style="position: relative"
    :class="[overflow ? 'bigbox' : '', readonly ? 'disabledBox' : '']"
  >
    <!-- <div v-if="readonly"
         style="position:absolute;width:100%;height:100%;z-index:10;overflow:auto;"></div> -->
    <div
      style="
        font-family: var(--body-font-family);
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      "
    >
      {{ label }}
    </div>
    <div ref="editorElem" :id="'editor' + name"></div>
    <div
      v-if="errMsg && errMsg.length > 0"
      style="color: #ff5252; font-size: 12px"
    >
      {{ errMsg[0] }}
    </div>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
import property from "./propertyDialog";
import AlertMenu from "./menu.js";
export default {
  components: {
    property,
  },
  props: {
    content: {},
    readonly: {
      type: Boolean,
    },
    menuShow: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    errMsg: {
      //验证
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
    },
    name: {},
    overflow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editor: null,
      editorData: "",
    };
  },
  watch: {
    content(val) {
      this.editorData = val;
      this.editor.txt.html(val);
    },
    readonly(val) {
      if (val) {
        this.editor.$textElem.attr("contenteditable", false);
        // this.editor.disable();
      } else {
        this.editor.$textElem.attr("contenteditable", true);
        // this.editor.enable();
      }
    },
  },
  mounted() {
    this.createEditor();
  },
  methods: {
    createEditor() {
      const editor = new wangEditor("#editor" + this.name);
      this.editorData = this.content;

      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) => {
        this.editorData = newHtml;
        this.$emit("changeContent", newHtml);
      };

      // editor.config.height = 300
      if (this.height) {
        editor.config.height = this.height;
      }
      editor.config.showFullScreen = false; //全屏预览
      editor.config.fontNames = ["黑体", "仿宋", "华文仿宋", "宋体"];
      // const menuKey = 'addproperty' // 菜单 key ，各个菜单不能重复
      // editor.menus.extend('addproperty', AlertMenu)

      // 将菜单加入到 editor.config.menus 中
      // 也可以通过配置 menus 调整菜单的顺序，参考【配置菜单】部分的文档
      // editor.config.menus = editor.config.menus.concat(menuKey)

      if (this.menuShow) {
        editor.config.menus = [];
      }
      // editor.config.onblur = (newHtml) => {
      //   this.$emit('insert', this.insert)
      // }
      // editor.config.onfocus = (newHtml) => {
      //   console.log(editor.selection.getSelectionText());
      // }
      // 创建编辑器
      editor.config.pasteFilterStyle = false;
      editor.config.zIndex = 5;
      editor.create();
      // 点击按钮，禁用编辑器
      //操作dom进行自定义菜单 自定义菜单
      // if (!this.menuShow) {
      //   const editordom = document.getElementsByClassName('w-e-toolbar')
      //   console.log(editordom, this.name);
      //   var div = document.createElement('div');
      //   div.className = "w-e-menu primary--text"
      //   div.innerHTML = `加入变数`;
      //   div.onclick = () => {
      //     this.$emit('addpro')
      //   }
      //   editordom[this.name + 1].appendChild(div)
      // }

      //加菜单禁用
      const editordom = document.querySelector(
        "#editor" + this.name + " " + ".w-e-toolbar"
      );
      var div = document.createElement("div");
      div.className = "menubox";
      editordom.appendChild(div);

      // console.log(editordom);
      // editordom.forEach(item => {
      //   item.appendChild(div)
      // })
      // const editorcontainer = document.getElementsByClassName('w-e-text-container')
      // var div = document.createElement('div');
      // div.className = "menubox"
      // editorcontainer[0].appendChild(div)

      // editor.txt.eventHooks.toolbarClickEvents.push(this.toolbarClickEvents)
      editor.txt.eventHooks.enterUpEvents.push(this.enterUp); //回车事件
      editor.txt.eventHooks.clickEvents.push(this.editClick); //点击事件事件
      // if (this.readonly) {
      //   editor.disable()
      // }
      // else {
      //   editor.enable()
      // }
      // 点击按钮，禁用编辑器

      // editor.txt.append(this.editorData)
      editor.txt.html(this.editorData);

      // 禁用编辑功能

      // 开启编辑功能
      // editor.$textElem.attr('contenteditable', true)
      // console.log(this.readonly);
      this.editor = editor; //富文本编辑器
      if (this.readonly) {
        //禁用
        editor.$textElem.attr("contenteditable", false);
        // editor.disable();
      } else {
        //启用
        editor.$textElem.attr("contenteditable", true);
        // editor.enable();
      }
    },
    delEditor() {
      this.editor.destroy();
      this.editor = null;
    },
    returnLabel(val) {
      if (
        this.$store.state.currentCompanyLanguage &&
        !this.$store.state.currentCompanyLanguage.length > 0
      )
        return;
      let str = null;
      this.$store.state.currentCompanyLanguage.forEach((item) => {
        if (val.toLowerCase() == item.value.toLowerCase()) {
          str = item.text;
        }
      });
      return str;
    },
    cloneContent() {
      this.editorData = this.$clone(this.content);
      this.editor.txt.html(this.editorData);
    },
    toolbarClickEvents(v) {
      // console.log(v, 45);
    },
    enterUp() {
      this.$emit("enterUp");
    },
    editClick() {},
    insert(val) {
      this.editor.cmd.do("insertText", val);
    },
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html();
      alert(data);
    },
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy();
    this.editor = null;
  },
};
</script>

<style>
.disabledBox .w-e-toolbar {
  z-index: 5 !important;
}
.disabledBox .menubox {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
.bigbox .w-e-text-container {
  height: 50vh;
  overflow: auto;
}
.w-e-text-container {
  min-height: 50vh;
}
.w-e-text table {
  border: none;
  margin: 0;
  padding: 0;
  /* border-top: 1px solid red; */
  /* border-left: 1px solid red; */
}
.w-e-text table td,
.w-e-text table th {
  border: none;
  margin: 0;
  padding: 0;
  /* border-bottom: 1px solid red; */
  /* border-right: 1px solid red; */
  /* padding: 3px 5px; */
}
.w-e-text table th {
  border: none;
  margin: 0;
  padding: 0;
  /* border-bottom: 2px solid red; */
  text-align: center;
}
/* blockquote 样式 */
.w-e-text blockquote {
  display: block;
  border-left: 8px solid #d0e5f2;
  padding: 5px 10px;
  margin: 10px 0;
  line-height: 1.4;
  font-size: 100%;
  background-color: #f1f1f1;
}

/* code 样式 */
.w-e-text code {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  background-color: #f1f1f1;
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;
}
.w-e-text pre code {
  display: block;
}

/* ul ol 样式 */
.w-e-text ul,
ol {
  margin: 10px 0 10px 20px;
}
</style>
